import React from "react";
import tw from 'tailwind-styled-components';
import Navbar from "./Navbar";
import Footer from "./Footer";

const Overflow = tw.div`
  overflow-x-hidden
  overflow-y-scroll
`;

const Container = tw.div`
  m-auto
`;

const Layout = ({ location, children }) => {
  return (
    <>
      <Overflow>
        <Container>
          <Navbar location={location} />
          {children}
        </Container>
        <Footer />
      </Overflow>
    </>
  )
};

export default Layout;
